export { default } from "./Verify.page";
